import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

// import PropTypes from "prop-types";
// import config from "../../../../config";
import { swalConfirm } from "../../../../component/Sweatalert2";
import { ClientdocumentGridViewApi, clientdocumentDeleteApi } from "store/slices/clientdocumentSlice";
import config from "../../../../config";
import { ellipseText } from "helpers/Functions";
import DocumentUpload from "component/form/DocumentUpload";
import InfiniteScroll from "react-infinite-scroll-component";
import PaginationLoader from "component/PaginationLoader";
import clientdocumentApiController from "../../../../services/clientdocument.service";
import { normalizeClientDocumentRow } from "../../../../services/clientDocumentContract";
import { shouldRenderClientHistoryEmptyState } from "../clientHistoryViewState";
import { getClientDocumentExtension, getClientDocumentName, getClientDocumentUploadDate, getClientDocumentUrl } from "./clientDocumentView";

const Documents = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const currentUser = auth.user;
  void (currentUser && currentUser.role_id);
  const [openModalTwo, setOpenModalTwo] = useState(false);
  useSelector(state => state.salonmodule.isAccess);
  const detail = useSelector((state) => state.client.isDetailData);
  const documentViews = useSelector((state) => state.clientdocument.isGridView);
  const documentListError = useSelector((state) => state.clientdocument.isGridViewError);
  const documentStatus = useSelector((state) => state.clientdocument?.isApiStatus?.ClientdocumentGridViewApi);

  const fetchDataPhotoList = () => {
    dispatch(ClientdocumentGridViewApi({ client_id: detail.id, next_page_url: documentViews.next_page_url }));
  };

  const [isFetching, setIsFetching] = useState(false);
  const loadMoreItemsList = () => {
    setIsFetching(true);
    dispatch(ClientdocumentGridViewApi({ next_page_url: documentViews && documentViews.next_page_url, client_id: detail.id }));
    //mocking an API call
    setTimeout(() => {
      setIsFetching(false);
    }, 2000);
  };

  const handleClientDelete = (e) => {
    const event = JSON.parse(e.currentTarget.dataset.obj);
    let confirmbtn = swalConfirm(e.currentTarget, { title: t("Are you sure want to delete?"), message: t("Success"), confirmButtonText: t("Yes, delete it!") });
    if (confirmbtn == true) {
      dispatch(clientdocumentDeleteApi({ id: event.id }));
    }
  };

  const handleDownload = async (document) => {
    const response = await clientdocumentApiController.download({ id: document.id });
    const objectUrl = window.URL.createObjectURL(response.data);
    const anchor = window.document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = document.document;
    anchor.click();
    window.URL.revokeObjectURL(objectUrl);
  };

  const documentRows = documentViews && Array.isArray(documentViews.data)
    ? documentViews.data
    : [];
  const showEmptyState = shouldRenderClientHistoryEmptyState({
    hasRows: documentRows.length > 0,
    isLoading: documentStatus === "loading",
    error: documentListError,
  }) && documentStatus === "succeeded";
  return (
    <>
      <div className="drawer-header">
        <h2 className="mb-4 pe-md-5 mb-lg-5">
          {t("Documents")} <DocumentUpload name="document" className="btn btn-outline btn-sm ms-2" accept=".pdf,.txt,.doc,.docx,.jpg,.jpeg,.png" label={t("Add Document")} page="client-adddocumentform" controlId="clientForm-document" client_id={detail.id} />
          {documentViews && documentViews.data && documentViews.data.length > 0 ? (
            <button className="btn btn-apricots btn-sm ms-2" onClick={() => setOpenModalTwo(true)}>Delete All</button>
          ) : ""}
        </h2>
      </div>
      {documentListError && (
        <div className="alert alert-danger mb-3" role="alert">
          {documentListError}
        </div>
      )}
      <div className="content-wrp" id="documentlist">
        {openModalTwo && (
          <>
            <div className={openModalTwo ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: openModalTwo ? "block" : "none" }}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-body pb-0">
                    <div className="p-3">
                      <h5 className="mb-3 fw-semibold text-dark">{t("Confirm all document deletion")}</h5>
                      <p className="fw-semibold mb-2">{t("Are you sure you want to delete all documents?")}</p>
                    </div>
                    <div className="row mt-3 bg-cream p-4 justify-content-center">
                      <div className="col-6">
                        <button className="preview btn me-1 cursor-pointer btn-preview w-100" type="button" onClick={() => {
                          setOpenModalTwo(false);
                        }}>
                          {t("Cancel")}
                        </button>
                      </div>
                      <div className="col-6">
                        <button className="btn btn-primary w-100" onClick={() => {
                          if (documentViews && documentViews.data && documentViews.data.length > 0) {
                            documentViews.data.forEach((doc) => {
                              dispatch(clientdocumentDeleteApi({ id: doc.id }));
                            });
                            setOpenModalTwo(false);
                          }
                        }} type="button">
                          {t("Confirm")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {openModalTwo && <div className="modal-backdrop show"></div>}
          </>
        )}
        {documentRows.length ? (
          <InfiniteScroll className="row gx-0" dataLength={documentViews.data.length} next={fetchDataPhotoList} scrollableTarget="documentlist" hasMore={documentViews.next_page_url ? true : false} loader={<PaginationLoader />}>
            {Object.keys(documentViews.data).map((item, i) => {
              const record = documentViews.data[item] || {};
              const document = normalizeClientDocumentRow(record);
              const documentName = getClientDocumentName(record);
              const documentUrl = getClientDocumentUrl(document);
              const uploadedAt = getClientDocumentUploadDate(document);
              const ext = getClientDocumentExtension(documentName);
              const canDownloadViaApi = Boolean(!documentUrl && document.id && document.storage_key);
              return (
                <div className="event-box" key={document.id || i}>
                  <div className="d-flex align-items-start">
                    <a>
                      <img src={config.imagepath + (ext === "pdf" ? "pdf.png" : "doc.png")} alt="" />
                    </a>
                    <div className="w-100 px-md-3 px-2">
                      <h6 className="mb-1">
                        <b>{ellipseText(documentName, "10")}</b>
                      </h6>
                      <p className="mb-2">
                        {t("uploaded")}: {uploadedAt || t("Upload date unavailable")}
                      </p>

                      {documentUrl ? (
                        <a href={documentUrl} target="_blank" rel="noreferrer" download={documentName} className="btn btn-outline btn-sm">
                          {t("Download")}
                        </a>
                      ) : canDownloadViaApi ? (
                        <button type="button" onClick={() => handleDownload(document)} className="btn btn-outline btn-sm">
                          {t("Download")}
                        </button>
                      ) : null}

                    </div>

                    <a className="remove cursor-pointer" data-obj={JSON.stringify(documentViews.data[item])} onClick={handleClientDelete}>
                      {t("Remove")}
                    </a>

                  </div>
                </div>
              );
            })}
            {!isFetching && documentViews.next_page_url && (
              <div className="col-2 m-auto p-3 text-center">
                <button onClick={loadMoreItemsList} className="btn btn-primary">
                  {t("More")}
                </button>
              </div>
            )}
          </InfiniteScroll>
        ) : showEmptyState ? (
          <div className="complete-box text-center d-flex flex-column justify-content-center mt-xl-4">
            <div className="complete-box-wrp text-center">
              <img src={config.imagepath + "docs.png"} alt="" className="mb-md-4 mb-3" />
              <h5 className="mb-2 fw-semibold">
                {t("Add documents and keep a record of your client’s treatments.")}
                <br />
                <DocumentUpload name="document" className="" accept=".pdf,.txt,.doc,.docx,.jpg,.jpeg,.png" label={t("Add your first document.")} page="client-adddocumentform-circle" controlId="clientForm-document" client_id={detail.id} />
                {/* <a
            className="add-document cursor-pointer"
            onClick={() => }
          >
            {t("Add your first document.")}
          </a> */}
              </h5>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

// Documents.propTypes = {
//   // props: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
// };

export default Documents;
